const code = [
  {
    label: 'Malaysia',
    value: '60'
  },
  {
    label: 'Indonesia',
    value: '62'
  },
  {
    label: 'Philippines',
    value: '63'
  },
  {
    label: 'Singapore',
    value: '65'
  },
  {
    label: 'Thailand',
    value: '66'
  },
  {
    label: 'Brunei',
    value: '673'
  },
  {
    label: 'Japan',
    value: '81'
  },
  {
    label: 'Korea',
    value: '82'
  },
  {
    label: 'Vietnam',
    value: '84'
  },
  {
    label: 'North Korea',
    value: '850'
  },
  {
    label: '香港(Hong Kong)',
    value: '852'
  },
  {
    label: '澳门(Macao)',
    value: '853'
  },
  {
    label: 'Cambodia',
    value: '855'
  },
  {
    label: 'Laos',
    value: '856'
  },
  {
    label: '中国(China)',
    value: '86'
  },
  {
    label: '台湾(Taiwan)',
    value: '886'
  },
  {
    label: 'Bangladesh',
    value: '880'
  },
  {
    label: 'Turkey',
    value: '90'
  },
  {
    label: 'India',
    value: '91'
  },
  {
    label: 'Pakistan',
    value: '92'
  },
  {
    label: 'Afghanistan',
    value: '93'
  },
  {
    label: 'Sri Lanka',
    value: '94'
  },
  {
    label: 'Myanmar',
    value: '95'
  },
  {
    label: 'Maldives',
    value: '960'
  },
  {
    label: 'Lebanon',
    value: '961'
  },
  {
    label: 'Jordan',
    value: '962'
  },
  {
    label: 'Syria',
    value: '963'
  },
  {
    label: 'Iraq',
    value: '964'
  },
  {
    label: 'Kuwait',
    value: '965'
  },
  {
    label: 'Saudi Arabia',
    value: '966'
  },
  {
    label: 'Oman',
    value: '968'
  },
  {
    label: 'Israel',
    value: '972'
  },
  {
    label: 'Bahrain',
    value: '973'
  },
  {
    label: 'Qatar',
    value: '974'
  },
  {
    label: 'Bhutan',
    value: '975'
  },
  {
    label: 'Mongolia',
    value: '976'
  },
  {
    label: 'Nepal',
    value: '977'
  },
  {
    label: 'Iran',
    value: '98'
  },
  {
    label: 'Russia',
    value: '7'
  },
  {
    label: 'Greece',
    value: '30'
  },
  {
    label: 'Netherlands',
    value: '31'
  },
  {
    label: 'Belgium',
    value: '32'
  },
  {
    label: 'France',
    value: '33'
  },
  {
    label: 'Spain',
    value: '34'
  },
  {
    label: 'Gibraltar',
    value: '350'
  },
  {
    label: 'Portugal',
    value: '351'
  },
  {
    label: 'Luxembourg',
    value: '352'
  },
  {
    label: 'Ireland',
    value: '353'
  },
  {
    label: 'Iceland',
    value: '354'
  },
  {
    label: 'Albania',
    value: '355'
  },
  {
    label: 'Malta',
    value: '356'
  },
  {
    label: 'Cyprus',
    value: '357'
  },
  {
    label: 'Finland',
    value: '358'
  },
  {
    label: 'Bulgaria',
    value: '359'
  },
  {
    label: 'Hungary',
    value: '336'
  },
  {
    label: 'Germany',
    value: '49'
  },
  {
    label: 'Yugoslavia',
    value: '338'
  },
  {
    label: 'Italy',
    value: '39'
  },
  {
    label: 'San Marino',
    value: '223'
  },
  {
    label: 'Vatican',
    value: '396'
  },
  {
    label: 'Romania',
    value: '40'
  },
  {
    label: 'Switzerland',
    value: '41'
  },
  {
    label: 'Liechtenstein',
    value: '4175'
  },
  {
    label: 'Austria',
    value: '43'
  },
  {
    label: 'United Kingdom',
    value: '44'
  },
  {
    label: 'Denmark',
    value: '45'
  },
  {
    label: 'Sweden',
    value: '46'
  },
  {
    label: 'Norway',
    value: '47'
  },
  {
    label: 'Poland',
    value: '48'
  },
  {
    label: 'Egypt',
    value: '20'
  },
  {
    label: 'Morocco',
    value: '210'
  },
  {
    label: 'Algeria',
    value: '213'
  },
  {
    label: 'Tunisia',
    value: '216'
  },
  {
    label: 'Libya',
    value: '218'
  },
  {
    label: 'Gambia',
    value: '220'
  },
  {
    label: 'Senegal',
    value: '221'
  },
  {
    label: 'Mauritania',
    value: '222'
  },
  {
    label: 'Mali',
    value: '223'
  },
  {
    label: 'Guinea',
    value: '224'
  },
  {
    label: 'Côte d\'Ivoire',
    value: '225'
  },
  {
    label: 'Burkina Faso',
    value: '226'
  },
  {
    label: 'Niger',
    value: '227'
  },
  {
    label: 'Togo',
    value: '228'
  },
  {
    label: 'Benin',
    value: '229'
  },
  {
    label: 'Mauritius',
    value: '230'
  },
  {
    label: 'Liberia',
    value: '231'
  },
  {
    label: 'Sierra Leone',
    value: '232'
  },
  {
    label: 'Ghana',
    value: '233'
  },
  {
    label: 'Nigeria',
    value: '234'
  },
  {
    label: 'Chad',
    value: '235'
  },
  {
    label: 'Central Africa',
    value: '236'
  },
  {
    label: 'Cameroon',
    value: '237'
  },
  {
    label: 'Cape Verde',
    value: '238'
  },
  {
    label: 'Sao Tome',
    value: '239'
  },
  {
    label: 'Princeby',
    value: '239'
  },
  {
    label: 'Equatorial Guinea',
    value: '240'
  },
  {
    label: 'Gabon',
    value: '241'
  },
  {
    label: 'Congo',
    value: '242'
  },
  {
    label: 'Zaire',
    value: '243'
  },
  {
    label: 'Angola',
    value: '244'
  },
  {
    label: 'Guinea Bissau',
    value: '245'
  },
  {
    label: 'Ascension',
    value: '247'
  },
  {
    label: 'Seychelles',
    value: '248'
  },
  {
    label: 'Sudan',
    value: '249'
  },
  {
    label: 'Rwanda',
    value: '250'
  },
  {
    label: 'Ethiopia',
    value: '251'
  },
  {
    label: 'Somali',
    value: '252'
  },
  {
    label: 'Djibouti',
    value: '253'
  },
  {
    label: 'Kenya',
    value: '254'
  },
  {
    label: 'Tanzania',
    value: '255'
  },
  {
    label: 'Uganda',
    value: '256'
  },
  {
    label: 'Burundi',
    value: '257'
  },
  {
    label: 'Mozambique',
    value: '258'
  },
  {
    label: 'Zambia',
    value: '260'
  },
  {
    label: 'Madagascar',
    value: '261'
  },
  {
    label: 'Reunion Island',
    value: '262'
  },
  {
    label: 'Zimbabwe',
    value: '263'
  },
  {
    label: 'Namibia',
    value: '264'
  },
  {
    label: 'Malawi',
    value: '265'
  },
  {
    label: 'Lesotho',
    value: '266'
  },
  {
    label: 'Botswana',
    value: '267'
  },
  {
    label: 'Swaziland',
    value: '268'
  },
  {
    label: 'Comoros',
    value: '269'
  },
  {
    label: 'South Africa',
    value: '27'
  },
  {
    label: 'Saint Helena',
    value: '290'
  },
  {
    label: 'Aruba',
    value: '297'
  },
  {
    label: 'Faroe Islands',
    value: '298'
  },
  {
    label: 'United States',
    value: '1'
  },
  {
    label: 'Canada',
    value: '1'
  },
  {
    label: 'Midway Island',
    value: '1808'
  },
  {
    label: 'Hawaii',
    value: '1808'
  },
  {
    label: 'Wake Island',
    value: '1808'
  },
  {
    label: 'Anguilla Island',
    value: '1809'
  },
  {
    label: 'Virgin Islands',
    value: '1809'
  },
  {
    label: 'Saint Lucia',
    value: '1809'
  },
  {
    label: 'Puerto Rico',
    value: '1809'
  },
  {
    label: 'Jamaica',
    value: '1809'
  },
  {
    label: 'The Bahamas',
    value: '1809'
  },
  {
    label: 'Barbados',
    value: '1809'
  },
  {
    label: 'Alaska',
    value: '1907'
  },
  {
    label: 'Greenland',
    value: '299'
  },
  {
    label: 'Falkland Islands',
    value: '500'
  },
  {
    label: 'Belize',
    value: '501'
  },
  {
    label: 'Guatemala',
    value: '502'
  },
  {
    label: 'El Salvador',
    value: '503'
  },
  {
    label: 'Honduras',
    value: '504'
  },
  {
    label: 'Nicaragua',
    value: '505'
  },
  {
    label: 'Costa Rica',
    value: '506'
  },
  {
    label: 'Panama',
    value: '507'
  },
  {
    label: 'Haiti',
    value: '509'
  },
  {
    label: 'Peru',
    value: '51'
  },
  {
    label: 'Mexico',
    value: '52'
  },
  {
    label: 'Cuba',
    value: '53'
  },
  {
    label: 'Argentina',
    value: '54'
  },
  {
    label: 'Brazil',
    value: '55'
  },
  {
    label: 'Chile',
    value: '56'
  },
  {
    label: 'Colombia',
    value: '57'
  },
  {
    label: 'Venezuela',
    value: '58'
  },
  {
    label: 'Bolivia',
    value: '591'
  },
  {
    label: 'Guyana',
    value: '592'
  },
  {
    label: 'Ecuador',
    value: '593'
  },
  {
    label: 'French Guiana',
    value: '594'
  },
  {
    label: 'Paraguay',
    value: '595'
  },
  {
    label: 'Martinique',
    value: '596'
  },
  {
    label: 'Suriname',
    value: '597'
  },
  {
    label: 'Uruguay',
    value: '598'
  },
  {
    label: 'Australia',
    value: '61'
  },
  {
    label: 'New Zealand',
    value: '64'
  },
  {
    label: 'Guam',
    value: '671'
  },
  {
    label: 'Cocos Island',
    value: '6722'
  },
  {
    label: 'Norfolk Island',
    value: '6723'
  },
  {
    label: 'Christmas Island',
    value: '6724'
  },
  {
    label: 'Nauru',
    value: '674'
  },
  {
    label: 'Tonga',
    value: '676'
  },
  {
    label: 'Solomon Islands',
    value: '677'
  },
  {
    label: 'Vanuatu',
    value: '678'
  },
  {
    label: 'Fiji',
    value: '679'
  },
  {
    label: 'Cork Islands',
    value: '682'
  },
  {
    label: 'Niue',
    value: '683'
  },
  {
    label: 'East Samoa',
    value: '684'
  },
  {
    label: 'Western Samoa',
    value: '685'
  },
  {
    label: 'Kiribati',
    value: '686'
  },
  {
    label: 'Tuvalu',
    value: '688'
  }
]

export default code
